import React from 'react';
import styles from './DeliveryStatusBadge.module.css';

interface DeliveryStatusBadgeProps {
  status: string;
}

const STATUS_COLOR_MAP: Record<string, string> = {
  'In Transit': 'yellow',
  Scheduled: 'blue',
  Completed: 'green',
  Failed: 'red',
};

export const DeliveryStatusBadge: React.FC<DeliveryStatusBadgeProps> = ({ status }) => {
  const color = STATUS_COLOR_MAP[status] || 'gray';
  return (
    <span className={`${styles.badge} ${styles[color]}`}>
      {status}
    </span>
  );
};
